export const resolveExerciseCardCoach = ({
  coachProp = null,
  block = null,
  exercise = null,
} = {}) =>
  coachProp ??
  block?.client?.coach ??
  exercise?.workout?.coach ??
  block?.coach ??
  exercise?.block?.coach ??
  null;
